var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout",
    d: "M47.293,58.759v-1.25a.64.64,0,0,0-.624-.625H42.506a.64.64,0,0,1-.624-.625V42.509a.64.64,0,0,1,.624-.625h4.162a.64.64,0,0,0,.624-.625v-1.25a.64.64,0,0,0-.624-.625H41.05a1.671,1.671,0,0,0-1.665,1.667V57.717a1.671,1.671,0,0,0,1.665,1.667h5.619a.64.64,0,0,0,.624-.625ZM59.2,49.8a.6.6,0,0,0,0-.875L53.578,43.3a.6.6,0,0,0-.874,0l-.874.875a.6.6,0,0,0,0,.875l2.331,2.333a.417.417,0,0,1-.291.708H45a.605.605,0,0,0-.624.583v1.25a.679.679,0,0,0,.624.667h8.824a.417.417,0,0,1,.291.708l-2.331,2.333a.6.6,0,0,0,0,.875l.874.875a.6.6,0,0,0,.874,0Z",
    transform: "translate(-39.385 -39.384)",
    fill: "#89cff0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.007b5a6d52adb79ab5900f997fb7c83c.svg";
export { ForwardRef as ReactComponent };